import Component from '@glimmer/component';

export default class BiIconComponent extends Component {}
